import React from "react";
import { formatPercentage, formatNumber, formatDate } from "../../../../utils";
import { STableRow, SFirstColumnCell, SCell, SBar } from "./styles";

interface RentabilityTableRowPropsType {
  asset: {
    color: string;
    label: string | null;
    key: string;
    yearVolatility: string | null;
    volatility: string | null;
    sharpe: string | null;
    returnDays: {
      positive: number | null;
      negative: number | null;
    };
    dailyReturn: {
      average: string | null;
      maximum: string | null;
      maximumDate: string | null;
      minimum: string | null;
      minimumDate: string | null;
    };
  };
  indented?: boolean;
}

export const VolatilityTableRow: React.FC<RentabilityTableRowPropsType> = ({
  asset,
  indented,
}) => {
  VolatilityTableRow.defaultProps = {
    indented: false,
  };

  return (
    <STableRow key={`inner-volatility-${asset.key}`}>
      <SFirstColumnCell>
        <SBar $barColor={asset.color} />
        {indented && <span>&nbsp;&nbsp;&nbsp;</span>}
        {asset.label}
      </SFirstColumnCell>
      <SCell>{formatPercentage(asset.yearVolatility)}</SCell>
      <SCell>{formatPercentage(asset.volatility)}</SCell>
      <SCell>{formatNumber(asset.sharpe)}</SCell>
      <SCell>{formatNumber(asset.returnDays.positive, 0)}</SCell>
      <SCell>{formatNumber(asset.returnDays.negative, 0)}</SCell>
      <SCell>{formatPercentage(asset.dailyReturn.average)}</SCell>
      <SCell>{formatPercentage(asset.dailyReturn.maximum)}</SCell>
      <SCell>{formatDate(asset.dailyReturn.maximumDate)}</SCell>
      <SCell>{formatPercentage(asset.dailyReturn.minimum)}</SCell>
      <SCell>{formatDate(asset.dailyReturn.minimumDate)}</SCell>
    </STableRow>
  );
};
